import React from 'react';
import {MESSAGE_ALERT} from "../constants";
import {sendMessage} from "../actions";
import {useDispatch} from "react-redux";

export default function useAlertMessage() {
    const dispatch = useDispatch();

    return message => dispatch(sendMessage(MESSAGE_ALERT, message));
}